export default __webpack_public_path__ + "static/media/docker.d33285e5.svg";